/* ==========================================================================
   Free Gift Box on orders >= $51.99
   - Below threshold: gift box is a normal paid product, untouched.
   - At/above threshold: one unit is auto-added, marked with a line item
     property (_auto_gift) so it's distinguishable from a unit the customer
     deliberately bought themselves. Auto-added units are auto-removed if the
     cart drops back below threshold. Manually-added units are never touched.
   - Pricing safety net lives entirely in Shopify (automatic discount
     "FREE GIFT BOX 5199", server-enforced usesPerOrderLimit: 1), NOT in this
     script -- so even if this script double-fires under a race, the customer
     is never charged 0 for more than one unit. This script's only job is
     convenience: getting the box into the cart automatically.
   Re-syncs after any /cart/add, /cart/change, /cart/update call (drawer,
   quantity steppers, Razorpay's buy-now button, etc.) by wrapping fetch.
   ========================================================================== */
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 52320292864301;
  var THRESHOLD_CENTS = 5199; // $51.99 in cents
  var AUTO_FLAG = '_auto_gift';
  var syncing = false;

  function otherItemsTotal(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (item.variant_id === GIFT_VARIANT_ID) return;
      total += item.line_price;
    });
    return total;
  }

  function findAutoGiftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.variant_id === GIFT_VARIANT_ID && item.properties && item.properties[AUTO_FLAG]) {
        return item;
      }
    }
    return null;
  }

  function hasAnyGift(cart) {
    return cart.items.some(function (item) { return item.variant_id === GIFT_VARIANT_ID; });
  }

  function refreshCartDrawerUI() {
    return fetch('/cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Swap the whole drawer body (not just cart-drawer-items) so the
        // empty-cart markup and the is-empty class -- which Shopify only
        // renders/toggles on a full section render, not on our raw
        // /cart/add.js call -- stay in sync with the real cart state.
        var target = document.querySelector('.drawer__inner');
        var source = doc.querySelector('.drawer__inner');
        if (target && source) target.replaceWith(source);

        var targetDrawer = document.querySelector('cart-drawer');
        var sourceDrawer = doc.querySelector('cart-drawer');
        if (targetDrawer && sourceDrawer) {
          targetDrawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
        }
      })
      .catch(function () {});
  }

  function sync() {
    if (syncing) return;
    syncing = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var eligible = otherItemsTotal(cart) >= THRESHOLD_CENTS;
        var autoLine = findAutoGiftLine(cart);

        if (eligible && !hasAnyGift(cart)) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _auto_gift: 'yes' } }]
            }),
            keepalive: true
          }).then(refreshCartDrawerUI);
        }

        if (!eligible && autoLine) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: autoLine.key, quantity: 0 }),
            keepalive: true
          }).then(refreshCartDrawerUI);
        }
      })
      .catch(function () { /* silent: never block the customer's cart */ })
      .finally(function () { syncing = false; });
  }

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
    var isCartMutation = typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url);
    var result = nativeFetch.apply(this, arguments);
    if (isCartMutation) {
      result.then(function (res) {
        if (res.ok) setTimeout(sync, 150);
        return res;
      }).catch(function () {});
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(
      'button[name="checkout"], a[href^="/checkout"], .shopify-payment-button__button, ' +
      '.magic-buy-btn, .magic-buy-btn__parent, .magic-cart-btn, .magic-checkout-btn, ' +
      '[data-magic-shopify-btn-ref], [data-magic-branded-btn-ref]'
    );
    if (trigger) sync();
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') sync();
  });

  // Safety net: some third-party/app scripts overwrite window.fetch after
  // this file runs, silently breaking the wrap above and its cart-mutation
  // detection. A cheap periodic check guarantees the gift box still gets
  // added/removed within a few seconds even when that happens.
  setInterval(sync, 4000);
})();
